module.exports = __webpack_public_path__ + "static/img/solutionDetailPic5.d93e4a6.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/solutionDetailPic5.png
// module id = SJ8V
// module chunks = 1